"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GUTTER_SIZES = {
  default: 32,
  sm: 16,
  xl: 96
};

var ResultsSection = _styledComponents.default.div.withConfig({
  displayName: "ResultsSection",
  componentId: "ll984y-0"
})(_templateObject(), function (props) {
  return GUTTER_SIZES[props.gutterSize];
});

ResultsSection.propTypes = {
  gutterSize: _propTypes.default.oneOf(['default', 'sm', 'xl'])
};
ResultsSection.defaultProps = {
  gutterSize: 'default'
};
var _default = ResultsSection;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/results/ResultsSection.js
// module id = 213
// module chunks = 209 210 211 212